// extracted by mini-css-extract-plugin
export default {"selected-image":"image-carousel_selected-image__KIjjN","container":"image-carousel_container__XjaPc","image-container":"image-carousel_image-container__yF12E"};